import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIncognitoOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 10H4L5.54 5.37C5.82 4.55 6.58 4 7.44 4H16.56C17.42 4 18.19 4.55 18.46 5.37L20 10Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 10H22",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 20C8.433 20 10 18.433 10 16.5C10 14.567 8.433 13 6.5 13C4.567 13 3 14.567 3 16.5C3 18.433 4.567 20 6.5 20Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 20C19.433 20 21 18.433 21 16.5C21 14.567 19.433 13 17.5 13C15.567 13 14 14.567 14 16.5C14 18.433 15.567 20 17.5 20Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 16.5H14",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIncognitoOutline;
